export const Logins = {
    SET_LOGINS: "SET_LOGINS"
} 

export const Logout = {
    SET_LOGOUT: "SET_LOGOUT"
} 